import { Component, OnInit, signal } from '@angular/core';
import { AuthRequest } from '../../models/authRequest';
import { UserDataService } from '../../services/user-data.service';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { TranslatePipe } from '@ngx-translate/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { UpperCasePipe } from '@angular/common';
import { PasswordResetComponent } from '../../modals/password-reset/password-reset.component';
import { ModalService } from '../../services/modal.service';

@Component({
  selector: 'app-login',
  imports: [TranslatePipe, FormsModule, ReactiveFormsModule, UpperCasePipe],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  constructor(
    private router: Router,
    private spinner: NgxSpinnerService,
    private userDataService: UserDataService,
    private fb: FormBuilder,
    private modalService: ModalService,
  ) {}

  error = signal<boolean>(false);

  loginForm!: FormGroup;
  showForgotPopup = false;
  passwordVisible = false;

  ngOnInit(): void {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]]
    });
  }

  togglePasswordVisibility() {
    this.passwordVisible = !this.passwordVisible;
  }

  onSubmit() {
    this.spinner.show();
    const auth: AuthRequest = this.loginForm.value;
    this.userDataService.auth(auth).subscribe({
      next: user => {
        this.spinner.hide();
        const needsActivation = !!(user?.emailActivationTermDate);
        if (needsActivation) {
          this.router.navigate(['/feedback'], {queryParams: {afterLogin: true}});
        } else {
          this.router.navigate(['/products']);
        }
      },
      error: _ => {
        this.spinner.hide();
        this.error.set(true);
      }
    });
  }

  goToRegisterPage() {
    this.router.navigate(['/register']);
  }

  openForgotPasswordModal() {
    this.modalService.show(PasswordResetComponent);
  }
}
